<template>
  <div>
    <breadcrumb :items="items"/>
    <p>{{ $t('app.messages') }}</p>
  </div>
</template>

<script>
export default {
  components: {
    Breadcrumb: () => import('@/components/Breadcrumb.vue'),
  },
  data() {
    return {
      items: [
        {
          text: this.$t('app.dashboard'),
          disabled: true,
          href: 'dashboard',
        },
        {
          text: this.$t('app.messages'),
          disabled: false,
          href: 'messages',
        },
      ],
    };
  },
};
</script>

<style scoped lang="scss">
  @import '~styles/views/_messages.scss';
</style>
